import { render, staticRenderFns } from "./businessTrip.vue?vue&type=template&id=7b6a3122&scoped=true&"
import script from "./businessTrip.vue?vue&type=script&lang=js&"
export * from "./businessTrip.vue?vue&type=script&lang=js&"
import style0 from "./businessTrip.vue?vue&type=style&index=0&id=7b6a3122&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6a3122",
  null
  
)

export default component.exports